import { prop } from 'ramda';
import { useSnackbar } from 'notistack';
import Snackbar from '@/components/Snackbar';

interface pushSnackbarProps {
  message: string;
  options: {
    variant: 'success' | 'warning' | 'error' | 'info';
    title?: string;
  };
  onClose: () => void;
}

export const useEnqueueSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const pushSnackbar = ({ message, options, onClose }: pushSnackbarProps) => {
    enqueueSnackbar(message, {
      ...options,
      onClose,
      content: (key) => {
        const variant = prop('variant', options);
        const title = prop('title', options);
        return (
          <Snackbar snackKey={key} title={title} content={message} variant={variant} closeSnackbar={closeSnackbar} />
        );
      },
    });
  };

  return pushSnackbar;
};
